<template>
    <div>
        <v-row class="mt-1">
            <v-col cols="12" sm="6" md="6">
                <v-row>
                    <v-col cols="12" sm="4" md="4"
                        v-for="(comm, ndx) in methodsList"
                        :key="ndx" >
                        <v-checkbox
                            v-model="comm_methods"
                            :label="comm.text"
                            :value="comm.value"
                            color="accent"
                            hide-details>
                        </v-checkbox>
                    </v-col>
                </v-row>
            </v-col>
             <v-col cols="12" sm="6" md="6">
                <v-row class="pt-5">    
                    <v-col cols="12" sm="6" md="6">
                        <h3 class="info--text">Location of Face to Face Meetings:</h3>
                        <v-text-field 
                            v-model="editData.comm_face_primary_office" 
                            label="Primary Office"
                            hint="percentage of occurance" 
                            persistent-hint 
                            append-icon="mdi-percent">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <h3>&nbsp;</h3>
                        <v-text-field 
                            v-model="editData.comm_face_secondary_office" 
                            label="Secondary Office"    
                            hint="percentage of occurance" 
                            persistent-hint 
                            append-icon="mdi-percent">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="editData.comm_face_clients_home" hint="percentage of occurance" persistent-hint append-icon="mdi-percent" label="Clients Home"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="editData.comm_face_clients_office" hint="percentage of occurance" persistent-hint append-icon="mdi-percent" label="Clients Office"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="editData.comm_face_other" label="Other"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="editData.comm_face_meeting_frequency" label="Meeting Frequency"></v-text-field>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>


<script>
    export default {
        name: 'CommunicationMethods',

        props: {
            editData: Object,
            methodsList: Array
        },

        computed: {
            comm_methods: {
                get: function() {
                    return this.editData.comm_methods != null ? this.editData.comm_methods : []
                },
                set: function(val) {
                    this.editData.comm_methods = val
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/prospectus-sections/CommunicationMethods.vue